<template>
    <div class="category-view">
        <ul>
            <li>
                <span style="background-color:#fcefef;"></span>
                <p>框架</p>
            </li>
            <li>
                <span style="background-color:#7fd8be"></span>
                <p>框架</p>
            </li>
            <li>
                <span style="background-color:#a1fcdf;"></span>
                <p>框架</p>
            </li>
            <li>
                <span style="background-color:#fcd29f;"></span>
                <p>框架</p>
            </li>
            <li>
                <span style="background-color:#fcab64;"></span>
                <p>框架</p>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "categoryView"
    };
</script>

<style lang="scss">
    .category-view {
        background-color: #fff;
        padding: 11px 0 0;

        ul,
        li {
            list-style: none;
        }
        ul > li {
            width: 20%;
            height: 85px;
            display: inline-block;
            text-align: center;
            box-sizing: border-box;
            span {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: inline-block;
                margin-bottom: 7px;
            }
        }
    }
</style>
